import { createSlice } from "@reduxjs/toolkit"
import { COLOR_PRIMARY } from "common/utils/theme"

const COLORS_PALETTE = [
  COLOR_PRIMARY,
  "#00d8ac",
  "#FFB200",
  "#FF3A29",
  "#353535",
]

const LAST_COLOR_USED = "documento_last_color_used"

const initialState = {
  // Colores
  userColors: COLORS_PALETTE,
  extraColor: localStorage.getItem(LAST_COLOR_USED) || "#ccc",
  colorSelected: localStorage.getItem(LAST_COLOR_USED) || COLORS_PALETTE[0],

  // Cuentas contables
  cuentaContableFactura: null,

  // Modales
  showDocumentoCreadoModal: false,
  showTituloModal: false,
  showFechaEmisionModal: false,
  showFechaVencimientoModal: false,
  showConceptosModal: false,
  showDatosLibradoModal: false,
  showRetencionModal: false,
  showFechaOperacionModal: false,
  showDescuentoModal: false,
  showObservacionesModal: false,
  showFormaPagoModal: false,
  showDiasPagoModal: false,
  showLogoModal: false,
  showAsociarDocumentosModal: false,

  // Nuevos campos
  showFechaOperacion: false,
  showDescuento: false,
  showObservaciones: false,
  showFormaPago: false,
  showDiasPago: false,
  showLogo: false,
  showRetencion: false,

  // Archivos adjuntos
  archivosAdjuntos: [],

  showDocumentoEditadoModal: false,
}

export const newDocumentoSettingsSlice = createSlice({
  name: "newDocumentoSettings",
  initialState,
  reducers: {
    // Colores
    updateColor(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.colorSelected = payload
      localStorage.setItem(LAST_COLOR_USED, payload)
    },
    selectExtraColor(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.extraColor = payload
      state.colorSelected = payload
      localStorage.setItem(LAST_COLOR_USED, payload)
    },

    // Cuentas contables
    setCuentaContableFactura(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.cuentaContableFactura = payload
    },

    // Modales
    setShowDocumentoCreadoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showDocumentoCreadoModal = payload
    },
    setShowTituloModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showTituloModal = payload
    },
    setShowFechaEmisionModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showFechaEmisionModal = payload
    },
    setShowFechaVencimientoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showFechaVencimientoModal = payload
    },
    setShowConceptosModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showConceptosModal = payload
    },
    setShowDatosLibradoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showDatosLibradoModal = payload
    },
    setShowFechaOperacionModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showFechaOperacionModal = payload
    },
    setShowDescuentoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showDescuentoModal = payload
    },
    setShowObservacionesModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showObservacionesModal = payload
    },
    setShowFormaPagoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showFormaPagoModal = payload
    },
    setShowDiasPagoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showDiasPagoModal = payload
    },
    setShowLogoModal(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.showLogoModal = payload
    },
    setShowRetencionModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showRetencionModal = payload
    },
    setShowAsociarDocumentosModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showAsociarDocumentosModal = payload
    },

    // Nuevos campos
    setShowFechaOperacion(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showFechaOperacion = payload
    },
    setShowDescuento(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.showDescuento = payload
    },
    setShowObservaciones(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showObservaciones = payload
    },
    setShowFormaPago(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.showFormaPago = payload
    },
    setShowDiasPago(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.showDiasPago = payload
    },
    setShowLogo(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.showLogo = payload
    },
    setShowRetencion(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.showRetencion = payload
    },

    // Archivos adjuntos
    setArchivosAdjuntos(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.archivosAdjuntos = payload
    },

    // Limpiar estado
    clearNewDocumentoSettingsState(
      state: $TSMigrationFixMe,
      { payload = null }
    ) {
      return {
        ...initialState,
        colorSelected: state.colorSelected,
        extraColor: state.extraColor,
        cuentaContableFactura: payload,
      }
    },
    setShowDocumentoEditadoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.showDocumentoEditadoModal = payload
    },
  },
})

export const {
  updateColor,
  selectExtraColor,
  setShowDocumentoCreadoModal,
  setShowTituloModal,
  setShowFechaEmisionModal,
  setShowFechaVencimientoModal,
  setShowConceptosModal,
  setShowDatosLibradoModal,
  setShowFechaOperacionModal,
  setShowDescuentoModal,
  setShowObservacionesModal,
  setShowFormaPagoModal,
  setShowDiasPagoModal,
  setShowLogoModal,
  setShowRetencionModal,
  setShowAsociarDocumentosModal,
  setShowFechaOperacion,
  setShowDescuento,
  setShowObservaciones,
  setShowFormaPago,
  setShowDiasPago,
  setShowLogo,
  setShowRetencion,
  clearNewDocumentoSettingsState,
  setArchivosAdjuntos,
  setCuentaContableFactura,
  setShowDocumentoEditadoModal,
} = newDocumentoSettingsSlice.actions
